import {
  CHILDMSISDN,
  SELECTED_LANG,
  TOKEN_ID,
  getApiEndpoint,
} from '../common/Constants';
import { LogTimetaken, consoleLog, getItem, getItemOfSessionStorage } from '../common/utils';
import { getEvenPlaces, getOddPlaces, output } from './ApiHeaders';

import axios from 'axios';
import { sha512 } from 'js-sha512';


export const callQueryapi = async ({ queryKey }) => {
  consoleLog('callapi', queryKey);

  const [key, endpoint, param, header, setnochild = false, domain] = queryKey;

  if (endpoint === null || endpoint === undefined) {
    return null;
  }
  const tokenid = await getItem(TOKEN_ID);
  let selectedlang = await getItem(SELECTED_LANG);
  try {
    if (selectedlang === null || selectedlang === undefined || selectedlang === "")
      // selectedlang = localStorage.getItem("lang");
      selectedlang = getItemOfSessionStorage(SELECTED_LANG);
  } catch (e) { }
  const childMSISDN = await getItem(CHILDMSISDN);
  consoleLog('key', key);
  consoleLog('endpoint', endpoint);
  consoleLog("selectedlang", selectedlang)
  consoleLog('param', JSON.stringify(param));
  consoleLog('Post API globaltoken', global.UniqueToken);
  consoleLog('Post API  globallang', global.userlanguage);
  consoleLog('Post API url', getApiEndpoint(endpoint));
  consoleLog('Request Headers', JSON.stringify(header));



  const currUnixTime = Date.now();
  const headerList = {
    ...getHeaderObject(
      tokenid,
      currUnixTime,
      param,
      selectedlang,
      childMSISDN,
      setnochild
    ),
    ...header,
  };
  let _finalurl = getApiEndpoint(endpoint, domain);

  if (window.location.href.indexOf("localhost") > 0) {
    headerList["proxypath"] = _finalurl;
    _finalurl = "http://localhost:9135/mockdata/postdata"
  }



  const res = await axios.post(
    _finalurl,
    param === null || param === undefined ? {} : JSON.stringify(param),
    {
      headers: headerList,
      timeout: 60000,
      timeoutErrorMessage: "Error Message",
    }
  );
  try {
    consoleLog('endpoint', getApiEndpoint(endpoint));
    consoleLog('param', JSON.stringify(param));
    consoleLog('headers', '-------------------------------------');
    consoleLog('headers', '-------------------------------------');
    consoleLog('headerList', res.headers);
    consoleLog('apiresponse', JSON.stringify(res.data));
    ///Not for Client Release
    // LogTextLog(endpoint, param, GetTimetaken(res));
    LogTimetaken(res);
  } catch (e) { }
  return res;
};

export const getImageHeaders = (tokenId, selectedLang) => {
  const currUnixTime = Date.now();
  try {
    let _tmpheaders = global.imageheaderslist;
    if (
      _tmpheaders !== null &&
      _tmpheaders !== undefined &&
      _tmpheaders?.length > 5
    ) {
      return _tmpheaders;
    }
  } catch (e) { }
  const headerList = {
    ...getImageHeaderObject(tokenId, currUnixTime, selectedLang),
  };

  global.imageheaderslist = headerList;
  return headerList;
};
const getImageHeaderObject = (tokenId, timestamp, languageSelected) => {
  const tokenid = tokenId ?? timestamp;
  const platform = "WEB";
  const osVersion = "1";
  const deviceUniqueId = "1";
  const appVersion = "1";
  let headerObj = {};
  const resolution = '90X90';
  var headerHash = `${getEvenPlaces(
    timestamp
  )}&${tokenid}$${timestamp}$${platform}$${osVersion}`;
  const childMSISDN = getItemOfSessionStorage(CHILDMSISDN);
  // let childMSISDN = global.setchildmsisdn_encrypt;
  if (childMSISDN != null && childMSISDN.length > 0) {
    headerHash = headerHash + '$' + childMSISDN;
  }
  const hdSignHash = sha512(headerHash);
  headerObj['User-Agent'] = output.userAgent;
  headerObj['X-IMI-App-OS'] = platform;
  headerObj['X-OS'] = platform;
  headerObj['X-IMI-App-Res'] = resolution;
  headerObj['X-IMI-App-Model'] = "WEB";
  headerObj['X-IMI-App-OSVersion'] = osVersion;
  // headerObj['X-IMI-App-UserAgent'] = `IMImobile/OoredooKuwait/${appVersion}`;
  headerObj['X-IMI-App-UserAgent'] = process.env.REACT_APP_USER_AGENT + process.env.REACT_APP_USER_AGENT_VERSION;
  // headerObj['X-IMI-CHANNEL'] = 'WEBPORTAL';
  headerObj['X-IMI-CHANNEL'] = process.env.REACT_APP_CHANNEL;
  //headerObj['X-IMI-CHANNEL'] = 'MOBAPP';
  headerObj['X-IMI-DEV-ID'] = deviceUniqueId;
  headerObj['X-IMI-HDSIGN'] = hdSignHash;
  headerObj['X-IMI-LANGUAGE'] = languageSelected;
  headerObj['X-IMI-NETWORK'] = output.networkType;
  headerObj['X-IMI-SERVICEKEY'] = 'A7A45FE9-ECAC-4393-BB40-357F1E5491F7';
  headerObj['X-IMI-TOKENID'] = tokenid?.toString() ?? '';
  headerObj['X-IMI-UID'] = timestamp?.toString() + '';
  headerObj['X-IMI-UNIQUEID'] = deviceUniqueId;
  headerObj['X-IMI-VERSION'] = appVersion;
  headerObj['X-IMI-RNST'] = new Date().getTime() + '';
  headerObj['X-IMI-APPTYPE'] = '1';
  if (childMSISDN != null && childMSISDN.length > 0) {
    consoleLog('------------CHILD-LINENO', childMSISDN);
    headerObj['X-IMI-CHILD-LINENO'] = childMSISDN;
  }
  return headerObj;
};

const getHeaderObject = (
  tokenId,
  timestamp,
  reqBody,
  languageSelected,
  childMSISDN,
  setnochild
) => {
  const tokenid = tokenId ?? timestamp;
  const platform = "WEB";
  const osVersion = "1";
  const deviceUniqueId = "1";
  const appVersion = "1";
  let headerObj = {};
  let width = window.screen.width;
  let height = window.screen.height;
  const resolution = `${String(width)}x${String(height)}`;
  let _tevenplaces = getEvenPlaces(timestamp);
  let headerHash = `${_tevenplaces}&${tokenid}$${timestamp}$${platform}$${osVersion}`;
  global.headerHash = headerHash;
  global.headerHashtime = timestamp;
  if (childMSISDN != null && childMSISDN.length > 0 && !setnochild) {
    headerHash = headerHash + '$' + childMSISDN;
  }
  const signatureKey = `${JSON.stringify(reqBody)}&SALT=${getOddPlaces(
    tokenid
  )}`;
  consoleLog('headerHash', headerHash);
  const hdSignHash = sha512(headerHash);
  consoleLog('hdSignHash', hdSignHash);
  const signatureHash = sha512(signatureKey);

  // console.log("SIGNATURE GENERATION->JSON.stringify(reqBody):"+JSON.stringify(reqBody)+"");
  // console.log("SIGNATURE GENERATION->tokenid:"+tokenid+",tokenid odd places:"+getOddPlaces(tokenid)+"");


  headerObj['User-Agent'] = output.userAgent;
  headerObj['X-IMI-App-OS'] = platform;
  headerObj['X-OS'] = platform;
  headerObj.Authorization =
    'Basic 8dbc05ac4f2912013157811dc578728bec6fc8a4c0d28f9cf0';
  headerObj['Content-Type'] = 'application/json';
  headerObj['X-IMI-App-Res'] = resolution;
  headerObj['X-IMI-App-Model'] = "WEB";
  headerObj['X-IMI-App-OSVersion'] = osVersion;
  // headerObj['X-IMI-App-UserAgent'] = `IMImobile/OoredooKuwait/${appVersion}`;
  headerObj['X-IMI-App-UserAgent'] = headerObj['X-IMI-App-UserAgent'] = process.env.REACT_APP_USER_AGENT + process.env.REACT_APP_USER_AGENT_VERSION;
  // headerObj['X-IMI-CHANNEL'] = 'WEBPORTAL';
  headerObj['X-IMI-CHANNEL'] = process.env.REACT_APP_CHANNEL;
  //headerObj['X-IMI-CHANNEL'] = 'MOBAPP';
  headerObj['X-IMI-DEV-ID'] = deviceUniqueId;
  headerObj['X-IMI-ISREMEMBER'] = '1';
  headerObj['X-IMI-HDSIGN'] = hdSignHash;
  headerObj['X-IMI-LANGUAGE'] = languageSelected;
  headerObj['X-IMI-NETWORK'] = output.networkType;
  headerObj['X-IMI-SERVICEKEY'] = 'A7A45FE9-ECAC-4393-BB40-357F1E5491F7';
  headerObj['X-IMI-SIGNATURE'] = signatureHash;
  headerObj['X-IMI-TOKENID'] = tokenid?.toString() ?? '';
  headerObj['X-IMI-UID'] = timestamp?.toString(); ///'1617866819752523';
  headerObj['X-IMI-UNIQUEID'] = deviceUniqueId;
  headerObj['X-IMI-VERSION'] = appVersion;
  headerObj['X-IMI-RNST'] = new Date().getTime() + '';
  headerObj['X-IMI-APPTYPE'] = '1';
  headerObj['X-TRANSFER-AUTH-UNIQUEID'] = deviceUniqueId || new Date().getTime();
  if (childMSISDN != null && childMSISDN.length > 0 && !setnochild) {
    consoleLog('------------CHILD-LINENO', childMSISDN);
    headerObj['X-IMI-CHILD-LINENO'] = childMSISDN;
  }
  consoleLog("  headerObj['X-IMI-TOKENID']", headerObj['X-IMI-TOKENID']);

  return headerObj;
};

// function GetUrlEndpoint(url) {
//   try {
//     let _u = url.replace(BASE_URL, '');
//     _u = _u
//       .replace('/', '_')
//       .replace('/', '_')
//       .replace('/', '_')
//       .replace('/', '_')
//       .replace('/', '_');
//     consoleLog('url', _u);
//     return _u;
//   } catch (e) { }
//   return '';
// }

export function LogTextLog(endpoint, input, timetaken) {
  try {
  } catch (e) {
    consoleLog(e);
  }
}
